export enum Size {
  SMALL,
  MEDIUM,
  LARGE,
  XLARGE,
  XXLARGE
}